export const EVENTS: Record<string, string> = {
  RESET: 'reset',
  ID_FOUND: 'idFound',
  FETCHED_CONTAINER: 'fetchedContainer',
  FETCHED_PLACE: 'fetchedPlace',
  CREATED_ORDER: 'createdOrder',
}
